import { exhaustiveCaseGuard, vReqT } from "src/helpers/utils";
import { CSSProperties, ExtractPropTypes, defineComponent } from "vue";

import { Guid } from "src/interfaces/InleagueApiV1";

import { Client } from "src/store/Client";

export enum Step {
  selectSeason = 1,
  selectPlayer = 2,
  selectProgram = 3,
  contactInfoAndVolunteerPrefs = 4,
  registrationForm = 5,
  reviewAndPay = 6,
  end
}

export type RegistrationJourneyDetail =
  | {step: Step.selectSeason}
  | {step: Step.selectPlayer, seasonUID: Guid}
  | {step: Step.selectProgram, seasonUID: Guid, playerID: Guid}
  | {step: Step.contactInfoAndVolunteerPrefs, seasonUID: Guid, playerID: Guid, competitionUIDs: Guid[]}
  | {step: Step.registrationForm, seasonUID: Guid, playerID: Guid, competitionUIDs: Guid[]}
  | {step: Step.reviewAndPay, seasonUID: Guid, playerID: Guid, competitionUIDs: Guid[]}

const propsDef = {
  detail: vReqT<RegistrationJourneyDetail>(),
} as const

export type RegistrationJourneyBreadcrumbElementProps = ExtractPropTypes<typeof propsDef>

export const RegistrationJourneyBreadcrumbElement = defineComponent({
  props: propsDef,
  setup(props) {
    return () => {
      const breadCrumbImgDims = {
        widthPx: 754,
        heightPx: 685
      } as const

      const style : CSSProperties = {width: (breadCrumbImgDims.widthPx / 4)  + "px"}

      return <div>
        <nav aria-label="Progress">
          {(() => {
            switch (props.detail.step) {
              case Step.selectSeason:
                return <img src={`${Client.value.publicPath}/img/breadcrumbs-1-season.png`} style={style}/>
              case Step.selectPlayer:
                return <img src={`${Client.value.publicPath}/img/breadcrumbs-2-player.png`} style={style}/>
              case Step.selectProgram:
                return <img src={`${Client.value.publicPath}/img/breadcrumbs-3-program.png`} style={style}/>
              case Step.contactInfoAndVolunteerPrefs:
                return <img src={`${Client.value.publicPath}/img/breadcrumbs-4-parent.png`} style={style}/>
              case Step.registrationForm:
                return <img src={`${Client.value.publicPath}/img/breadcrumbs-5-regform.png`} style={style}/>
              case Step.reviewAndPay:
                return <img src={`${Client.value.publicPath}/img/breadcrumbs-6-pay.png`} style={style}/>
              default: exhaustiveCaseGuard(props.detail)
            }
          })()}
        </nav>
      </div>
    }
  }
})
